import React from 'react'
import qs from 'query-string'
import { history } from 'services/configureStore'

const strToInt = v => {
  if (typeof v === 'string') {
    return parseInt(v, 10)
  }

  return v
}

export const defaultFormatRules = {
  QStoComp: {
    page: strToInt,
    productCategoryID: strToInt,
    rootId: strToInt,
    productId: strToInt,
    isActual: v => {
      if (v === 'false') {
        return false
      }

      return true
    },
    isNew: v => {
      if (v === 'true') return true
      return false
    },
    isFavorite: v => {
      if (v === 'true') return true
      return false
    },
    levelFrom: strToInt,
    levelTo: strToInt,
    withdrawalId: strToInt,
  },
  compToQS: {
    page: v => {
      if (v === 1) {
        return ''
      }

      return v
    },
    isActual: v => {
      if (v === true) {
        return ''
      }

      return v
    },
    isNew: v => {
      if (v === false) return ''
      return v
    },
    isFavorite: v => {
      if (v === false) return ''
      return v
    },
  },
}

const formatter = (obj, rules) => {
  const keys = Object.keys(obj)

  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i]
    if (typeof rules[key] === 'function') {
      obj[key] = rules[key](obj[key])
    }

    if (!obj[key] && obj[key] !== 0 && obj[key] !== false) {
      delete obj[key]
    }
  }

  return obj
}

const queryStringSyncEnhancer = (WrappedComponent, formatRules = defaultFormatRules) => {
  const getQueryParams = () => {
    const parsedParams = qs.parse(window.location.search)
    return formatter(parsedParams, formatRules.QStoComp)
  }

  const updateQueryParams = obj => {
    const formattedObj = formatter({ ...obj }, formatRules.compToQS)
    const newQueryString = qs.stringify({ ...formattedObj })
    history.push({ pathname: window.location.pathname, search: newQueryString })
  }

  const updateQueryParam = obj => updateQueryParams({...getQueryParams(), ...obj})

  return props => {
    return (
      <WrappedComponent
        {...props}
        getQueryParams={getQueryParams}
        updateQueryParams={updateQueryParams}
        updateQueryParam={updateQueryParam}
      />
    )
  }
}

export default queryStringSyncEnhancer
